module.exports = __webpack_public_path__ + "static/img/bz2.df5d332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/bz2.png
// module id = KduV
// module chunks = 53